import { IdValue } from '../../../shared/models/id-value.model';

export const PMITypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'Monthly', 'Monthly'),
  new IdValue(2, 'Standard Annual', 'Standard Annual'),
  new IdValue(3, 'Single Prem. Refundable', 'Single Prem. Refundable'),
  new IdValue(4, 'Single Prem. Non-Refundable', 'Single Prem. Non-Refundable'),
  new IdValue(5, 'Lender Paid', 'Lender Paid'),
  new IdValue(6, 'Split Prem. Non-Refundable', 'Split Prem. Non-Refundable'),
];

export enum miQuoteMappings {
  enact = '113',
  mgic = '4',
  nationalMI = '112',
  radian = '7',
}
